<template lang="html">
  <div class="title">
    <!-- <div class="left" v-if="isDashboard">
      <span class="time">{{time}}</span>
      <span class="weekdays">
      {{weekdays}}</span>
      </div>
    <div class="left back" v-else @click="back">返回</div> -->
    <h1 @click="back">{{ name }}</h1>
    <!-- <div class="right" v-if="isDashboard">技术支持：海南现代设施农业研究院有限公司</div> -->
    <div class="right" v-if="isDashboard">技术支持：浙江甲骨文科技集团</div>
    <div class="right" v-else></div>
  </div>
</template>

<script>
import moment, { weekdays } from "moment";
import "moment/locale/zh-cn";
const daysArr = ["日", "一", "二", "三", "四", "五", "六"];
export default {
  props: {
    name: String,
    isDashboard: {
      type: Boolean,
      default: false
    },
    onBack: false
  },
  created() {},
  methods: {
    back() {
      // console.log(this.timerDashboard)
      // if (this.onBack) {
      //   this.$emit('backClick');
      // } else {
      //   this.$router.push('/rundadashboard');
      // }
    }
  },
  data() {
    return {
      color: this.$store.state.color,
      // time: moment().format('LLLL')
      time: `${moment().format("YYYY.MM.DD")} `,
      weekdays: `星期${daysArr[moment().day()]}`
    };
  }
};
</script>

<style lang="less" scoped>
@import "../../../assets/font/font.css";

.title {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 7300/1080vh;
  background: url("../../../assets/img/yinxiao/top.png");
  background-size: 100% 100%;
  color: white;

  h1 {
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    font-size: 4300/1080vh;
    font-weight: bold;
    text-align: center;
    line-height: 7300/1080vh;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    text-shadow: 0px 5px 5px rgba(0, 25, 110, 0.75);
    // background: linear-gradient(
    //   0deg,
    //   rgba(193, 193, 193, 0.5) 0%,
    //   rgba(255, 255, 255, 1) 10%,
    //   rgba(255, 255, 255, 1) 100%
    // );
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
    // letter-spacing: 10px;
  }

  .left,
  .right {
    // margin-top: 68px;
    margin-top: -0.1vh;
    width: 50%;
    height: 55px;
    line-height: 55px;
    font-family: "digital";
  }

  .left {
    padding-left: 36px;
    text-align: left;
    font-size: 22px;
    font-weight: 400;
    .weekdays {
      font-size: 20px;
      font-weight: 400;
    }
    .title {
      height: 18px;
      font-size: 22px;
      font-weight: 400;
    }
  }

  .right {
    width: auto;
    position: absolute;
    right: 3600/1980vw;
    top: 6000/1080vh;
    font-size: 1800/1080vh;
    font-weight: bold;
    text-align: center;
    line-height: 3200/1080vh;
    font-weight: bold;

    .brand {
      margin-right: 30px;
      font-size: 20px;
      font-weight: 400;
    }
  }

  .back {
    position: relative;
    padding-left: 55px;
    cursor: pointer;

    &:before {
      content: "";
      position: absolute;
      top: 13px;
      left: 22px;
      width: 26px;
      height: 24px;
      margin-right: 10px;
      background: url("../../../../static/img/common/back.png");
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?67c17fc1